module.exports = __webpack_public_path__ + "97860b6e499d5cf2bb909f7f00d551c4.svg";